<nz-form-item>
  <nz-form-label nzFor="customerSiteContractType">Type contrat</nz-form-label>
  <nz-form-control [nzErrorTip]="error">
    <nz-select [formControl]="formControl" nzMode="default" nzPlaceHolder="Type contrat" nzAllowClear [nzSize]="typeSize" class="w-100-p">
      <nz-option *ngFor="let customerSiteContractType of customerSiteContractTypeValues" [nzValue]="customerSiteContractType" [nzLabel]="customerSiteContractType | customerSiteContractTypeName | nullCoal"></nz-option>
    </nz-select>
  </nz-form-control>
  <ng-template #error let-control>
    <ng-container *ngIf="control?.hasError('required')">
      Le type contrat est requis
    </ng-container>
  </ng-template>
</nz-form-item>
